import { motion } from "framer-motion";
import * as Icons from "lucide-react";
import { MapPin, Navigation } from "lucide-react";
import { Button } from "../ui/button";
import { HOTEL, TRANSIT, ATTRACTIONS } from "@/data/site";

export const LocationSection = () => {
  const mapSrc = `https://www.google.com/maps?q=${encodeURIComponent(HOTEL.mapQuery)}&output=embed`;
  const directions = `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(HOTEL.mapQuery)}`;

  return (
    <section id="location" className="py-16 lg:py-24 px-4 sm:px-6 lg:px-12 max-w-7xl mx-auto">
      <span className="text-sm font-semibold uppercase tracking-[0.15em] text-primary">Find Us</span>
      <h2 className="mt-2 font-serif text-3xl sm:text-4xl font-semibold">Perfectly Placed in Khamla</h2>
      <p className="mt-3 text-muted-foreground max-w-2xl leading-relaxed flex items-start gap-2">
        <MapPin className="h-5 w-5 text-primary shrink-0 mt-0.5" /> {HOTEL.address}
      </p>

      <div className="mt-8 grid lg:grid-cols-2 gap-8">
        <motion.div
          initial={{ opacity: 0, x: -30 }} whileInView={{ opacity: 1, x: 0 }} viewport={{ once: true }} transition={{ duration: 0.6 }}
          className="rounded-2xl overflow-hidden border border-border shadow-sm h-[360px]"
        >
          <iframe title="map" src={mapSrc} className="w-full h-full" loading="lazy" referrerPolicy="no-referrer-when-downgrade" />
        </motion.div>

        <div className="space-y-6">
          <div>
            <h3 className="font-serif text-xl font-semibold flex items-center gap-2"><Navigation className="h-5 w-5 text-secondary" /> Getting Around</h3>
            <div className="mt-4 space-y-2.5">
              {TRANSIT.map((t) => {
                const Icon = Icons[t.icon] || Icons.MapPin;
                return (
                  <div key={t.name} className="flex items-center gap-3 rounded-xl border border-border bg-card p-3.5">
                    <span className="w-10 h-10 rounded-lg bg-primary/10 text-primary flex items-center justify-center shrink-0"><Icon className="h-5 w-5" /></span>
                    <div className="min-w-0">
                      <div className="text-sm font-medium truncate">{t.name}</div>
                      <div className="text-xs text-muted-foreground font-mono">{t.distance}</div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>

          <div>
            <h3 className="font-serif text-xl font-semibold">Nearby Attractions</h3>
            <div className="mt-3 grid grid-cols-2 gap-2.5">
              {ATTRACTIONS.map((a) => (
                <div key={a.name} className="rounded-xl bg-muted/60 p-3">
                  <div className="text-sm font-medium">{a.name}</div>
                  <div className="text-xs text-muted-foreground font-mono">{a.distance}</div>
                </div>
              ))}
            </div>
          </div>

          <a href={directions} target="_blank" rel="noopener noreferrer" data-testid="get-directions-button">
            <Button className="w-full h-11 bg-secondary hover:bg-secondary/90 gap-2"><Navigation className="h-4 w-4" /> Get Directions</Button>
          </a>
        </div>
      </div>
    </section>
  );
};
